<template>
    <component v-if="translate && translate.key" :is="element" class="translation">
        {{ t(translate) }}
    </component>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Element } from './Translation.interfaces';
    import { Translate } from '@shared/interfaces/translation';
    import { t } from '@shared/helpers/translation';

    export default defineComponent({
        name: 'Translation',
        components: {},
        props: {
            translate: Object as PropType<Translate>,
            element: {
                type: String as PropType<Element>,
                default: 'span',
            },
        },
        setup() {
            return { t };
        },
    });
</script>

<style lang="scss">
    @forward './Translation.scss';
</style>
